(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('announcement-rotator')) {
    customElements.define(
      'announcement-rotator',
      class AnnouncementRotator extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('.announcement__slide'));
          if (this.slides.length < 2) return;

          // Honour reduced motion by simply not cycling.
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          this.index = 0;
          const interval = Number(this.dataset.interval) || 5000;
          this.timer = setInterval(() => this.next(), interval);

          this.addEventListener('mouseenter', () => clearInterval(this.timer));
          this.addEventListener('mouseleave', () => {
            this.timer = setInterval(() => this.next(), interval);
          });
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        next() {
          this.slides[this.index].classList.remove('is-active');
          this.index = (this.index + 1) % this.slides.length;
          this.slides[this.index].classList.add('is-active');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  if (!customElements.get('address-fields')) {
    class AddressFields extends HTMLElement {
      connectedCallback() {
        this.countrySelect = this.querySelector('[data-address-country]');
        this.provinceSelect = this.querySelector('[data-address-province]');
        this.provinceWrapper = this.querySelector('[data-address-province-wrapper]');
        if (!this.countrySelect || !this.provinceSelect) return;

        const defaultCountry = this.dataset.defaultCountry || '';
        const defaultProvince = this.dataset.defaultProvince || '';

        if (defaultCountry) {
          this.countrySelect.value = defaultCountry;
        }

        this.countrySelect.addEventListener('change', () => this.updateProvinces(''));
        this.updateProvinces(defaultProvince);
      }

      updateProvinces(selected) {
        const option = this.countrySelect.options[this.countrySelect.selectedIndex];
        let provinces = [];
        if (option) {
          try {
            provinces = JSON.parse(option.getAttribute('data-provinces') || '[]');
          } catch (error) {
            provinces = [];
          }
        }

        this.provinceSelect.innerHTML = '';

        if (provinces.length) {
          provinces.forEach((pair) => {
            const optionEl = document.createElement('option');
            optionEl.value = pair[0];
            optionEl.textContent = pair[1];
            this.provinceSelect.appendChild(optionEl);
          });
          if (selected) this.provinceSelect.value = selected;
          if (this.provinceWrapper) this.provinceWrapper.hidden = false;
        } else if (this.provinceWrapper) {
          this.provinceWrapper.hidden = true;
        }
      }
    }

    customElements.define('address-fields', AddressFields);
  }

  if (!customElements.get('address-delete-form')) {
    class AddressDeleteForm extends HTMLElement {
      connectedCallback() {
        this.addEventListener('submit', (event) => {
          const button = event.submitter;
          const message = button && button.dataset.confirmMessage;
          if (message && !window.confirm(message)) {
            event.preventDefault();
          }
        });
      }
    }

    customElements.define('address-delete-form', AddressDeleteForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  if (!customElements.get('facet-filters')) {
    class FacetFilters extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.ajaxEnabled = this.dataset.ajaxEnabled === 'true';
        this.debounceTimer = null;

        if (!this.ajaxEnabled) return;

        this.classList.add('is-enhanced');
        this.bind();
      }

      bind() {
        this.addEventListener('submit', (event) => {
          const form = event.target.closest('[data-facets-form]');
          if (!form) return;
          event.preventDefault();
          this.applyForm(form, true);
        });

        this.addEventListener('change', (event) => {
          const field = event.target.closest('[data-facets-form] input, [data-facets-form] select');
          if (!field) return;
          const form = field.closest('form') || this.querySelector('[data-facets-form]');
          window.clearTimeout(this.debounceTimer);
          this.debounceTimer = window.setTimeout(() => this.applyForm(form, false), 150);
        });

        this.addEventListener('click', (event) => {
          const link = event.target.closest('[data-facets-remove], [data-facets-clear]');
          if (!link) return;
          event.preventDefault();
          this.applyUrl(link.href, true);
        });

        const toggle = this.querySelector('[data-facets-toggle-input]');
        if (toggle) {
          toggle.addEventListener('change', () => {
            if (toggle.checked) {
              this.lockScroll(true);
              window.requestAnimationFrame(() => {
                const panel = this.querySelector('[data-facets-panel]');
                const focusable = panel && panel.querySelector('a, button, input, select');
                if (focusable) focusable.focus();
              });
            } else {
              this.lockScroll(false);
              const trigger = this.querySelector('[data-facets-toggle-label]');
              if (trigger) trigger.focus();
            }
          });

          this.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && toggle.checked) {
              toggle.checked = false;
              toggle.dispatchEvent(new Event('change'));
            }
          });
        }
      }

      lockScroll(locked) {
        document.documentElement.classList.toggle('scroll-locked', locked);
      }

      applyForm(form, closeDrawer) {
        if (!form) return;
        const params = new URLSearchParams(new FormData(form));
        const url = `${form.getAttribute('action')}?${params.toString()}`;
        this.applyUrl(url, closeDrawer);
      }

      applyUrl(url, closeDrawer) {
        const fetchUrl = new URL(url, window.location.origin);
        fetchUrl.searchParams.set('section_id', this.sectionId);

        this.classList.add('is-loading');

        fetch(fetchUrl.toString())
          .then((response) => response.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const next = doc.querySelector('facet-filters');
            if (!next) return;

            const toggle = this.querySelector('[data-facets-toggle-input]');
            const wasOpen = toggle ? toggle.checked : false;

            this.innerHTML = next.innerHTML;
            this.classList.add('is-enhanced');
            this.bind();

            const newToggle = this.querySelector('[data-facets-toggle-input]');
            if (newToggle) newToggle.checked = closeDrawer ? false : wasOpen;
            if (closeDrawer) this.lockScroll(false);

            const cleanUrl = new URL(url, window.location.origin);
            cleanUrl.searchParams.delete('section_id');
            window.history.pushState({ facets: true }, '', cleanUrl.pathname + cleanUrl.search);
          })
          .catch(() => {
            window.location.href = url;
          })
          .finally(() => {
            this.classList.remove('is-loading');
          });
      }
    }

    customElements.define('facet-filters', FacetFilters);

    window.addEventListener('popstate', () => window.location.reload());
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  if (!customElements.get('login-panels')) {
    class LoginPanels extends HTMLElement {
      connectedCallback() {
        this.loginPanel = this.querySelector('[data-login-panel]');
        this.recoverPanel = this.querySelector('[data-recover-panel]');

        this.addEventListener('click', (event) => {
          const link = event.target.closest('[data-login-link]');
          if (!link) return;
          event.preventDefault();
          this.show(link.dataset.loginLink);
          window.history.replaceState(null, '', link.getAttribute('href'));
        });

        window.addEventListener('hashchange', () => this.sync());
        this.sync();
      }

      sync() {
        this.show(window.location.hash === '#recover' ? 'recover' : 'login');
      }

      show(name) {
        const showRecover = name === 'recover';
        if (this.recoverPanel) this.recoverPanel.hidden = !showRecover;
        if (this.loginPanel) this.loginPanel.hidden = showRecover;
      }
    }

    customElements.define('login-panels', LoginPanels);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    /**
     * Keeps the live price in the add to cart label. ProductForm (assets/theme.js)
     * sets the label back to button.dataset.defaultLabel on every variant:change, so
     * this writes the new label there first, then updates the text when the variant
     * can be bought. It works whichever listener runs first, and leaves the sold out
     * and unavailable text alone.
     */
    document.addEventListener('variant:change', (event) => {
      const variant = event.detail && event.detail.variant;
      const money = window.MasterTheme && window.MasterTheme.formatMoney;
      if (!variant || !money) return;
      document.querySelectorAll('button[data-atc-price]').forEach((button) => {
        const label = (button.dataset.atcLabel || '') + ' \u00B7 ' + money(variant.price);
        button.dataset.defaultLabel = label;
        const text = button.querySelector('.button__text');
        if (variant.available && text) text.textContent = label;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-ugc-wall"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pdp-ugc-wall')) {
    class PdpUgcWall extends HTMLElement {
      connectedCallback() {
        this.triggers = Array.from(this.querySelectorAll('[data-wall-open]'));
        this.modal = this.querySelector('dialog');
        this.modalVideo = this.querySelector('[data-wall-modal-video]');
        this.modalHandle = this.querySelector('[data-wall-modal-handle]');
        this.modalCaption = this.querySelector('[data-wall-modal-caption]');
        this.closeBtn = this.querySelector('[data-wall-close]');
        this.rail = this.querySelector('[data-ugc-wall-rail]');

        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (this.rail) {
          this.updateScrollEdges = this.updateScrollEdges.bind(this);
          this.rail.addEventListener('scroll', this.updateScrollEdges, { passive: true });
          window.addEventListener('resize', this.updateScrollEdges);
          this.updateScrollEdges();
        }

        this.triggers.forEach((trigger) => {
          trigger.addEventListener('click', () => this.openModal(trigger));

          if (!this.reducedMotion) {
            const video = trigger.querySelector('[data-wall-video]');
            if (video) {
              trigger.addEventListener('pointerenter', () => this.playPreview(video));
              trigger.addEventListener('pointerleave', () => this.pausePreview(video));
              trigger.addEventListener('focus', () => this.playPreview(video));
              trigger.addEventListener('blur', () => this.pausePreview(video));
            }
          }
        });

        if (this.closeBtn && this.modal) {
          this.closeBtn.addEventListener('click', () => this.modal.close());
        }

        if (this.modal) {
          this.modal.addEventListener('click', (event) => {
            if (event.target === this.modal) this.modal.close();
          });

          this.modal.addEventListener('close', () => {
            if (!this.modalVideo) return;
            this.modalVideo.pause();
            this.modalVideo.removeAttribute('src');
            this.modalVideo.load();
            if (this.opener) this.opener.focus({ preventScroll: true });
          });
        }

        if (!this.reducedMotion && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const video = entry.target.querySelector('[data-wall-video]');
                if (!video) return;
                if (entry.isIntersecting) {
                  this.playPreview(video);
                } else {
                  this.pausePreview(video);
                }
              });
            },
            { threshold: 0.6 }
          );
          this.triggers.forEach((trigger) => this.observer.observe(trigger));
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.updateScrollEdges) window.removeEventListener('resize', this.updateScrollEdges);
      }

      updateScrollEdges() {
        if (!this.rail) return;
        const maxScroll = this.rail.scrollWidth - this.rail.clientWidth;
        const hasMoreStart = this.rail.scrollLeft > 4;
        const hasMoreEnd = this.rail.scrollLeft < maxScroll - 4;

        this.rail.toggleAttribute('data-has-more-start', hasMoreStart);
        this.rail.toggleAttribute('data-has-more-end', hasMoreEnd);
      }

      playPreview(video) {
        if (this.reducedMotion) return;
        if (!video.src && video.dataset.src) video.src = video.dataset.src;
        const promise = video.play();
        if (promise && promise.catch) promise.catch(() => {});
      }

      pausePreview(video) {
        video.pause();
      }

      openModal(trigger) {
        if (!this.modal || !this.modalVideo) return;
        this.opener = trigger;
        this.modalVideo.src = trigger.dataset.src;
        this.modalVideo.muted = false;
        this.modalVideo.currentTime = 0;

        if (this.modalHandle) this.modalHandle.textContent = trigger.dataset.handle || '';
        if (this.modalCaption) this.modalCaption.textContent = trigger.dataset.caption || '';

        if (!this.modal.open) this.modal.showModal();

        const playPromise = this.modalVideo.play();
        if (playPromise && playPromise.catch) playPromise.catch(() => {});

        window.requestAnimationFrame(() => {
          if (this.closeBtn) this.closeBtn.focus();
        });
      }
    }

    customElements.define('pdp-ugc-wall', PdpUgcWall);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('stat-counter')) {
    class StatCounter extends HTMLElement {
      connectedCallback() {
        this.target = parseFloat(this.dataset.count);
        if (Number.isNaN(this.target)) return;

        this.decimals = (String(this.dataset.count).split('.')[1] || '').length;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.animated = false;

        if (this.reducedMotion || !('IntersectionObserver' in window)) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && !this.animated) {
                this.animated = true;
                this.animate();
                this.observer.unobserve(this);
              }
            });
          },
          { threshold: 0.4 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      format(value) {
        return value.toFixed(this.decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }

      animate() {
        const duration = 1400;
        const start = performance.now();
        const to = this.target;

        const step = (now) => {
          const elapsed = now - start;
          const progress = Math.min(elapsed / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          this.textContent = this.format(to * eased);

          if (progress < 1) {
            window.requestAnimationFrame(step);
          } else {
            this.textContent = this.format(to);
          }
        };

        window.requestAnimationFrame(step);
      }
    }
    customElements.define('stat-counter', StatCounter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('carousel-autoplay')) {
    class CarouselAutoplay extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        if (!this.track) return;

        this.dots = Array.from(this.querySelectorAll('.testimonial-carousel__dot'));
        this.autoplay = this.dataset.autoplay === 'true';
        this.speed = parseInt(this.dataset.speed, 10) || 5000;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.timer = null;
        this._scrollTimer = null;

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            this.goTo(parseInt(dot.dataset.carouselDot, 10));
          });
        });

        this.track.addEventListener('scroll', () => {
          window.clearTimeout(this._scrollTimer);
          this._scrollTimer = window.setTimeout(() => this.syncDots(), 100);
        });

        this.addEventListener('pointerenter', () => this.stop());
        this.addEventListener('pointerleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());

        if (this.autoplay && !this.reducedMotion) this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      start() {
        if (!this.autoplay || this.reducedMotion) return;
        this.stop();
        this.timer = window.setInterval(() => this.next(), this.speed);
      }

      stop() {
        if (this.timer) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }

      currentIndex() {
        const slideWidth = this.track.clientWidth || 1;
        return Math.round(this.track.scrollLeft / slideWidth);
      }

      next() {
        const count = this.track.children.length;
        if (!count) return;
        const nextIndex = (this.currentIndex() + 1) % count;
        this.goTo(nextIndex);
      }

      goTo(index) {
        const slide = this.track.children[index];
        if (!slide) return;
        this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }

      syncDots() {
        if (!this.dots.length) return;
        const index = this.currentIndex();
        this.dots.forEach((dot, i) => {
          const active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
        });
      }
    }
    customElements.define('carousel-autoplay', CarouselAutoplay);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upsell-row"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    class UpsellAddAll extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button) return;

        this.button.addEventListener('click', async () => {
          const row = this.closest('.upsell-row');
          if (!row || !window.MasterTheme) return;

          const items = Array.from(row.querySelectorAll('[data-upsell-item]'))
            .map((el) => Number(el.dataset.variantId))
            .filter(Boolean)
            .map((id) => ({ id, quantity: 1 }));

          if (!items.length) return;

          this.button.setAttribute('aria-busy', 'true');
          try {
            await window.MasterTheme.cart.add(items);
          } catch (error) {
            /* MasterTheme.cart already surfaces a toast/error via the cart:error event. */
          } finally {
            this.button.removeAttribute('aria-busy');
          }
        });
      }
    }

    if (!customElements.get('upsell-add-all')) {
      customElements.define('upsell-add-all', UpsellAddAll);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
